import { ZenJsUtils } from '@zen/common-app-parts';

const oraclePubKeyTest = '0365772539ac7dac9afcdb8e4a446512a96ef5de868ec7995e2fbb2e6d604a0362';
const oraclePubKeyMain = '020dc7cad106e9284be13576f5271c4f694da464076d2eb44fd5c74265316f70a3';

const oracles = [
  {
    chain: 'test',
    address: ZenJsUtils.getPublicKeyAddress('test', oraclePubKeyTest),
    publicKey: oraclePubKeyTest,
    dataSource: 'Intrinio',
    dataSourceUrl: 'https://intrinio.com',
    commitDataAt: '16:00',
    contractId: '00000000ea0491531b62de13d9760c6d9dd4046316080d1339daae5d2072811815c6bbe3',
    serviceUrl: 'https://oracle-test.zp.io',
  },
  {
    chain: 'main',
    address: ZenJsUtils.getPublicKeyAddress('main', oraclePubKeyMain),
    publicKey: oraclePubKeyMain,
    dataSource: 'Intrinio',
    dataSourceUrl: 'https://intrinio.com',
    commitDataAt: '16:00',
    contractId: '00000000065ee39e9f6af7d6e185f5b72eace28cc48bba05969742f0f9066519f3452369',
    serviceUrl: 'https://oracle-main.zp.io',
  },
];

export default oracles;

/**
 * @typedef {{
  chain: ('test'|'main'),
  address: string,
  publicKey: string,
  dataSource: string,
  dataSourceUrl: string,
  commitDataAt: string,
  contractId: string,
  serviceUrl: string,
}} OracleConfig
*/
